import {Ease} from "../../core/Animatable";
import {Callback} from "../../core/Reflection";
import {SceneItem} from "../SceneItem";
import {Animation} from "./Animation";
import {AnimationContext} from "./AnimationContext";

export class PulseAnimation extends Animation {

    public animate(item: SceneItem, context: AnimationContext, cb: Callback): void {
        const s = item.scale.x;
        const t = this.time || 0.8;
        const repeat = (start?: boolean) => {
            item.scaleTo(s * (this.speed || 0.8), t * 0.1, Ease.sineOut, {
                delay: start ? this.delay : undefined,
                onStart: start ? cb : undefined,
                onUpdate: () => this.updatePaperCut(item),
                onComplete: () => {
                    item.scaleTo(s, t * 0.9, Ease.bounceOut, {
                        onUpdate: () => this.updatePaperCut(item),
                        onComplete: repeat,
                    });
                },
            });
        };
        if (this.delay) {
            this.updatePaperCut(item);
        }
        repeat(true);
    }
}
